import type { MetricValue } from '@chukua/common';
import { formatMoney } from '../../../shared/policies/format-money';

const number = new Intl.NumberFormat('en-KE');

function formatDuration(totalSeconds: number): string {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  return hours > 0 ? `${hours} h ${minutes} min` : `${minutes} min`;
}

/** A figure as the screen shows it. A ratio shows its integers beside the percentage, because the records behind it are the denominator's. */
export function formatMetric(metric: MetricValue): string {
  switch (metric.kind) {
    case 'money':
      return formatMoney(metric);
    case 'count':
      return number.format(metric.value);
    case 'duration_seconds':
      return formatDuration(metric.value);
    case 'ratio':
      return metric.denominator === 0
        ? `0 of 0`
        : `${Math.round((metric.numerator / metric.denominator) * 100)}% (${number.format(metric.numerator)} of ${number.format(metric.denominator)})`;
  }
}
